import React, { useState, useEffect, useRef, useCallback } from "react";

import Arrow from "../Assests/Diabetes/arrow_1.png";
import sec1 from "../Assests/Wellness/Sec2_1.png";
import sec2 from "../Assests/Wellness/Sec2-2.png";
import sec3 from "../Assests/Wellness/Sec2_3.png";
import sec4 from "../Assests/Wellness/Sec2_4.png";
import sec5 from "../Assests/Wellness/Sec2_5.png";
import sec6 from "../Assests/Wellness/Sec_6.png";

// A helper function to process highlighted text:
// It finds <span style='color: #DA6E0B'>...</span> portions and, if they include "and",
// splits the content so that "and" is rendered outside the span while each part gets a bold font.
function processHighlight(content) {
  const regex = /<span style=['"]color:\s*#DA6E0B['"]>(.*?)<\/span>/g;
  return content.replace(regex, (match, innerText) => {
    if (/\band\b/i.test(innerText)) {
      // Split on "and", trimming extra spaces.
      const parts = innerText.split(/\s*\band\b\s*/);
      return parts
        .map((part) => `<span style="color: #DA6E0B; font-weight: bold">${part}</span>`)
        .join(" and ");
    } else {
      return `<span style="color: #DA6E0B; font-weight: bold">${innerText}</span>`;
    }
  });
}

const contentData = [
  {
    heading: "Addressing the Root Cause",
    img: sec1,
    content1:
      "Traditional medical approaches often focus on symptom management, providing short-term relief without addressing the underlying factors contributing to an individual’s health concerns.",
    content2:
      "In contrast, our Whole-System Medicine (WSM) approach is designed to go beyond symptom control by identifying and addressing the <span style='color: #DA6E0B'>root causes</span> of metabolic, gastric, and women’s wellness concerns.",
  },
  {
    heading: "AI Powered Diagnosis",
    img: sec2,
    content1:
      "In modern healthcare, one of the biggest challenges is accurately diagnosing underlying health imbalances before they manifest as chronic conditions.",
    content2:
      "Our study leverages AI-driven diagnostics to provide a personalized, data-driven assessment, ensuring that interventions are tailored to each individual’s <span style='color: #DA6E0B'>unique physiological and health profile</span>.",
  },
  {
    heading: "Ayurvedic Doctor Consultation",
    img: sec3,
    content1:
      "True healing goes beyond prescriptions-it requires a personalized, holistic approach that aligns with your body’s unique needs.",
    content2:
      "With the AIWeLL™ wellness protocol, you don’t just get a treatment plan-you get one-on-one <span style='color: #DA6E0B'>expert guidance</span> from experienced Ayurveda doctors.",
  },
  {
    heading: "Biomarker Assessment",
    img: sec4,
    content1:
      "Our study leverages advanced gut <span style='color: #DA6E0B'>microbiome analysis and blood biomarker</span> evaluations to gain deeper insights into individual health profiles.",
    content2:
      "By integrating these objective biological assessments with symptom-based evaluations and AI-powered diagnostics, we aim to identify root causes and craft personalized interventions that promote long-term well-being.",
  },
  {
    heading: "Personalized Recommendations",
    img: sec5,
    content1:
      "Wellness strategies require a comprehensive, personalized approach tailored to your body's unique needs.",
    content2:
      "The AIWeLL™ protocol offers a 360° wellness plan, seamlessly integrating personalized <span style='color: #DA6E0B'>diet, targeted herbal medicine, and lifestyle modifications</span> to restore balance and enhance well-being.",
  },
  {
    heading: "Precision Diet",
    img: sec6,
    content1:
      "Adapting to a new diet doesn’t have to mean extreme restrictions or giving up the foods you love.",
    content2:
      "With the AIWeLL™ protocol, we utilize gut microbiome analysis and Ayurvedic phenotyping to fine-tune your diet-allowing you to make <span style='color: #DA6E0B'>small, sustainable adjustments</span> that deliver <span style='color: #DA6E0B'>big results</span>.",
  },
];


const Page2 = () => {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const startAutoScroll = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev < contentData.length - 1 ? prev + 1 : 0));
    }, 4000);
  }, []);

  useEffect(() => {
    startAutoScroll();
    return () => clearInterval(intervalRef.current);
  }, [startAutoScroll]);

  // Update: Disable auto scroll when manually navigating
  const handleManualNav = (newIndex) => {
    setIndex(newIndex);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleNext = () => {
    const nextIndex = index < contentData.length - 1 ? index + 1 : 0;
    handleManualNav(nextIndex);
  };

  return (
    <div id="scroll-container" style={{ height: "100vh", overflow: "hidden" }}>
      <div className="page2-container-new">
        <div className="title-container">
          <h2 className="title">Our Unique Solution</h2>
        </div>

        <div className="content-container">
          <div className="page2-left-section">
            <div className="menu">
              {contentData.map((item, i) => (
                <div
                  key={i}
                  className={`menu-item ${i === index ? "active" : ""}`}
                  onClick={() => handleManualNav(i)}
                  style={{ cursor: "pointer" }}
                >
                  {item.heading}
                </div>
              ))}
            </div>
          </div>

          <div className="right-section">
            <img src={contentData[index].img} alt="Solution" className="icon" />
            <p className="description-new">{contentData[index].heading}</p>
            {/* Process content1 and content2 through processHighlight */}
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: processHighlight(contentData[index].content1),
              }}
            ></p>
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: processHighlight(contentData[index].content2),
              }}
            ></p>
          </div>
          <button onClick={handleNext} className="arrow-button">
            <img src={Arrow} alt="Next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Page2;
